<div class="help-dialog"
     cdkDrag cdkDragRootElement=".cdk-overlay-pane" [cdkDragDisabled]="!ventana.flotante"
     [class.ventana-flotante]="ventana.flotante" [class.ventana-minimizada]="ventana.isMinimized">
    <div class="help-header ventana-asa" cdkDragHandle>
        <h2 mat-dialog-title class="ventana-titulo">{{ data.title }}</h2>
        <div class="help-header-actions" *ngIf="ventana.flotante">
            <button mat-icon-button class="ventana-btn-minimizar" (click)="ventana.toggle()"
                    [title]="ventana.isMinimized ? 'Restaurar' : 'Minimizar'" [attr.aria-label]="ventana.isMinimized ? 'Restaurar' : 'Minimizar'">
                <mat-icon>{{ ventana.isMinimized ? 'open_in_full' : 'remove' }}</mat-icon>
            </button>
            <button mat-icon-button (click)="close()" aria-label="Cerrar">
                <mat-icon>close</mat-icon>
            </button>
        </div>
    </div>
    <mat-dialog-content>
        <div class="help-item" *ngFor="let item of data.items">
            <p>
                <mat-icon *ngIf="item.icon" [style.color]="item.iconColor || 'inherit'" class="help-icon">{{ item.icon }}</mat-icon>
                <strong>{{ item.term }}:</strong>
                {{ item.description }}
            </p>
        </div>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
        <button mat-button mat-dialog-close>Cerrar</button>
    </mat-dialog-actions>
</div>
